import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { toggleVideoModal } from '../../features/videos/videosSlice';
import moment from 'moment';
import { useAddVideoMutation, useEditVideoMutation } from '../../features/videos/videosApi';
import { customStyles } from '../../utils/constantVariables';


Modal.setAppElement('#root');

const validationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  url: Yup.string().required('URL is required'),
  views: Yup.string().required('Views is required'),
  duration: Yup.string().required('Duration is required'),
  createdAt: Yup.string().required('Date is required')
});


function VideoForm() {
  //Variables
  const { isVideoModalOpen, videoFormData } = useSelector((state) => state.videos);
  const { id, title, description, url, views, duration, createdAt } = videoFormData || {};
  const dispatch = useDispatch();
  const [addVideo, { isSuccess: addSuccess, isError: addError, isLoading: editLoading }] = useAddVideoMutation();
  const [editVideo, { isSuccess: editSuccess, isError: editError, isLoading: addLoading }] = useEditVideoMutation();
  const initialValues = {
    title: title || '',
    description: description || '',
    url: url || '',
    views: views || '',
    duration: duration || '',
    createdAt: moment(createdAt).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD')
  }

  //Hooks
  useEffect(() => {
    if (addSuccess || editSuccess) {
      dispatch(toggleVideoModal(false));
    }
  }, [addSuccess, editSuccess, dispatch])

  const { values, handleBlur, handleChange, handleSubmit, touched, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const payload = { ...values }
      if (id) {
        editVideo({ id: id, data: payload })
      } else {
        addVideo({ data: payload });
      }
    },
  });

  //Functions
  const handleModal = () => {
    dispatch(toggleVideoModal(!isVideoModalOpen));
  }

  return (
    <div>
      <Modal
        isOpen={isVideoModalOpen}
        onRequestClose={handleModal}
        style={customStyles}
      >
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name">Title:</label>
            <input
              type="text"
              id="title"
              name="title"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.title}
            />
            {touched.title && errors.title ? (
              <div className='form-error'>{errors.title}</div>
            ) : null}
          </div>
          <div>
            <label htmlFor="name">Description:</label>
            <input
              type="text"
              id="description"
              name="description"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.description}
            />
            {touched.description && errors.description ? (
              <div className='form-error'>{errors.description}</div>
            ) : null}
          </div>
          <div>
            <label htmlFor="name">URL:</label>
            <input
              type="text"
              id="url"
              name="url"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.url}
            />
            {touched.url && errors.url ? (
              <div className='form-error'>{errors.url}</div>
            ) : null}
          </div>
          <div>
            <label htmlFor="name">Views:</label>
            <input
              type="text"
              id="views"
              name="views"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.views}
            />
            {touched.views && errors.views ? (
              <div className='form-error'>{errors.views}</div>
            ) : null}
          </div>
          <div>
            <label htmlFor="name">Duration:</label>
            <input
              type="text"
              id="duration"
              name="duration"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.duration}
            />
            {touched.duration && errors.duration ? (
              <div className='form-error'>{errors.duration}</div>
            ) : null}
          </div>
          <div>
            <label htmlFor="name">Created At:</label>
            <input
              type="date"
              id="createdAt"
              name="createdAt"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.createdAt}
            />
            {touched.createdAt && errors.createdAt ? (
              <div className='form-error'>{errors.createdAt}</div>
            ) : null}
          </div>
          <div className='form-footer'>
            <button type='close' onClick={handleModal}>
              Close
            </button>
            <button type='submit' disabled={addLoading || editLoading}>
              Submit
            </button>
          </div>

        </form>
      </Modal>

    </div>
  )
}

export default VideoForm